import {
  Email,
  Facebook,
  FacebookOutlined,
  FacebookTwoTone,
  Instagram,
  LinkedIn,
  Map,
  Phone,
  Twitter,
  YouTube,
} from "@mui/icons-material";
import React from "react";
import { settingContext } from "../../../context/Setting/Setting";
import { _retrieveData } from "../../../utils/local-storage";
import Style from "./footer.module.scss";
import { Link } from "react-router-dom";
import moment from "moment";
import "./footer.css"

function Footer(props) {
  const { setting } = props;
  const { page, loading } = React.useContext(settingContext);


  return (
    <footer id="footer" className="footer">
      <div className="first-footer">
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-sm-12">
              <img style={{ resizeImage: 'cover', width: '100%', height: 100, marginRight: 10, marginTop: 5 }} src={process.env.REACT_APP_LOCAL_FILE_PATH +
                "page/large/" + page?.sponsor_image?.find((item) => item.page_type === "sponsor-image_3")['image']} />
                <img style={{ resizeImage: 'cover', width: '100%', height: 100, marginRight: 10, marginTop: 5 }} src={process.env.REACT_APP_LOCAL_FILE_PATH +
                    "page/large/" + page?.sponsor_image?.find((item) => item.page_type === "sponsor-image_1")['image']} />
              {/* <div className="logo">
                <img width={100}
                   src={process.env.REACT_APP_LOCAL_FILE_PATH + 'setting/small/' + page?.setting?.logo} loading="lazy" />
              </div> */}
              {/* <div className="widget megacourse">
                <h3 className="md">{page?.setting?.app_name}</h3>
                <p>{page?.setting?.description}</p>
                <Link to="/auth/register" className="mc-btn btn-style-1">Get started</Link>
              </div> */}
            </div>
            {/* <div className="col-md-3">
              <div className="widget widget_latest_new">
                <h3 className="sm">Latest News</h3>
                <ul>
                  <li>
                    <a href="#">
                      <div className="image-thumb">
                        <img src="http://tk-themes.net/html-megacourse/images/team-13.jpg" alt="" />
                      </div>
                      <span>How to have a good Boyfriend in college?</span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <div className="image-thumb">
                        <img src="http://tk-themes.net/html-megacourse/images/team-13.jpg" alt="" />
                      </div>
                      <span>How to have a good Boyfriend in college?</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div> */}
            <div className="col-md-2">
              {/* <div className="widget quick_link">
                <h3 className="sm">Quick Links</h3>
                <ul className="list-style-block">
                  <li><Link to="/">Home</Link></li>
                  <li><Link to="/acknowledgement" >Acknowledgement</Link></li>
                  <li><Link to="/courses">Courses</Link></li>
                  <li><Link to="/certificate/verify">Verification</Link></li>
                  <li><Link to="/testimonial">Testimonial</Link></li>
                  <li><a href={`mailto:${page?.setting?.official_email}`}>Contact</a></li>
                </ul>
              </div> */}
            </div>
            <div className="col-md-3">
              <div className="widget quick_link">
                <h3 className="sm">Socials</h3>
                <ul className="list-style-block">
                  {page?.setting?.facebook && <li><a href={page?.setting?.facebook}>Facebook</a></li>}
                  {page?.setting?.twitter && <li><a href={page?.setting?.twitter}>Twitter</a></li>}
                  {page?.setting?.instagram && <li><a href={page?.setting?.instagram}>Instagram</a></li>}
                  {page?.setting?.linkedin && <li><a href={page?.setting?.linkedin}>LinkedIn</a></li>}
                  {/* <li><a target="blank" href="https://lakeshorecancercenter.org/">Contact</a></li> */}
                </ul>
              </div>
            </div>
            <div className="col-md-3 col-sm-12">
                  <img style={{ resizeImage: 'cover', width: '100%', height: 100, marginRight: 10, marginTop: 5 }} src={process.env.REACT_APP_LOCAL_FILE_PATH +
                    "page/large/" + page?.sponsor_image?.find((item) => item.page_type === "sponsor-image_2")['image']} />
                  <img style={{ resizeImage: 'cover', width: '100%', height: 100, marginRight: 10, marginTop: 5 }} src={process.env.REACT_APP_LOCAL_FILE_PATH +
                    "page/large/" + page?.sponsor_image?.find((item) => item.page_type === "sponsor-image_feat")['image']} />
                  
{/* 
                  <div className="coverAds"></div> */}
            </div>
          </div>
        </div>
      </div>
      <div className="second-footer">
        <div className="container">
          <p className="">Copyright © {moment().format("YYYY")} {page?.setting?.company} | Designed & Managed by Apex Lonack Technology. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
